import React from 'react';
import Brochures from './Brochures';

const BrochuresMasterclasses = () => <Brochures fixedCategory="training" />;

export default BrochuresMasterclasses;
